import { useState } from 'react'
import { ImageWrapper } from './Image.styles'
import { ImageProps } from './Image.types'
import ImageGeneric from 'assets/icons/image_generic.svg'

export const Image = ({
    src,
    alt,
    width,
    height,
    borderRadius,
    'data-testid': testId,
}: ImageProps) => {
    const [isLoaded, setIsLoaded] = useState(!src)
    const [isError, setIsError] = useState(!src)

    const handleLoaded = (
        event: React.SyntheticEvent<HTMLImageElement, Event>
    ) => {
        !isLoaded && setIsLoaded(true)
    }

    const handleError = (
        event: React.SyntheticEvent<HTMLImageElement, Event>
    ) => {
        setIsError(true)
    }

    return (
        <ImageWrapper
            width={width}
            height={height}
            borderRadius={borderRadius}
            isLoaded={isLoaded}
            isError={isError}
        >
            <img
                src={isError ? ImageGeneric : src}
                alt={alt}
                onError={handleError}
                onLoad={handleLoaded}
                loading="lazy"
                data-testid={testId}
            />
        </ImageWrapper>
    )
}
